import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import LegalPage from "@/pages/LegalPage";
import SeoHead from "@/components/SeoHead";
import WhatsAppChat from "@/components/WhatsAppChat";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App grain-overlay">
      <LanguageProvider>
        <BrowserRouter>
          <SeoHead />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projekte/:slug" element={<ProjectDetail />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="/impressum" element={<LegalPage page="impressum" />} />
            <Route path="/datenschutz" element={<LegalPage page="privacy" />} />
          </Routes>
          <WhatsAppChat />
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#1c1c1e",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: 0,
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
